import React from "react";
import faUser from "@fortawesome/fontawesome-free-solid/faUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BRAND_COLOURS } from "../../../../constants";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const SendMessageSelectRecipientItem = ({
    user,
    recipients,
    selectParticipant
}) => {
    let userChoiceClass = "user-choice";

    if (recipients.includes(user.id)) {
        userChoiceClass += " selected";
    }

    return (
        <React.Fragment>
            <style jsx>
                {`
                    .user-choice {
                        width: 100%;
                        cursor: pointer;
                        display: inline-block;
                        padding: 1rem;
                        border: 2px dashed rgba(0, 0, 0, 0.2);
                        margin-right: 10px;
                        vertical-align: top;
                        max-height: 200px;
                        overflow-y: scroll;
                        margin-bottom: 1rem;
                    }
                    .user-choice:hover {
                        background-color: ${BRAND_COLOURS.light};
                    }
                    .user-choice.selected {
                        border: 2px solid ${BRAND_COLOURS.primary};
                    }
                    .user-choice > * {
                        pointer-events: none;
                    }
                    .title {
                        padding-bottom: 5px;
                        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
                    }
                    .interests {
                        margin: 1rem 0;
                        text-transform: uppercase;
                    }
                    .user-icon {
                        font-size: 90%;
                        margin-right: 5px;
                    }
                `}
            </style>
            <div
                className={userChoiceClass}
                onClick={() => selectParticipant(user.id)}
            >
                <div className={"h5 title"}>
                    <span className="user-icon float-left">
                        <FontAwesomeIcon icon={faUser as IconProp} />
                    </span>
                    {user.title ? user.title : <em>User</em>}
                    {user.purpose_for_using_convergence_v2 &&
                        user.purpose_for_using_convergence_v2.includes(
                            "Connect with active deals"
                        ) && (
                            <small className="badge badge-success float-right">
                                Looking for active deals
                            </small>
                        )}
                </div>
                <div className={"h5 interests"}>Interests</div>
                <dl className={"mb-0"}>
                    <dt>Deal Types</dt>
                    <dd>
                        {user.preferences.deal_types &&
                        user.preferences.deal_types.length > 0 ? (
                            user.preferences.deal_types.join(", ")
                        ) : (
                            <em>--- Empty ---</em>
                        )}
                    </dd>
                    <dt>Regions</dt>
                    <dd>
                        {user.preferences.regions_v2 &&
                        user.preferences.regions_v2.length > 0 ? (
                            user.preferences.regions_v2.join(", ")
                        ) : (
                            <em>--- Empty ---</em>
                        )}
                    </dd>
                    <dt>Countries</dt>
                    <dd>
                        {user.preferences.countries &&
                        user.preferences.countries.length > 0 ? (
                            user.preferences.countries.join(", ")
                        ) : (
                            <em>--- Empty ---</em>
                        )}
                    </dd>
                    <dt>Sectors</dt>
                    <dd>
                        {user.preferences.sectors &&
                        user.preferences.sectors.length > 0 ? (
                            user.preferences.sectors.join(", ")
                        ) : (
                            <em>--- Empty ---</em>
                        )}
                    </dd>
                    <dt>Sub-Sectors</dt>
                    <dd>
                        {user.preferences.sub_sectors &&
                        user.preferences.sub_sectors.length > 0 ? (
                            user.preferences.sub_sectors.join(", ")
                        ) : (
                            <em>--- Empty ---</em>
                        )}
                    </dd>
                </dl>
            </div>
        </React.Fragment>
    );
};

SendMessageSelectRecipientItem.propTypes = {};

export default SendMessageSelectRecipientItem;
